import {useEffect, useState} from "react";
import {Period} from "../api/types";
import dayjs, {Dayjs} from "dayjs";

export function usePeriodDates(period: Period, isWeekInterval: boolean) {
  const [dates, setDates] = useState<Dayjs[]>([])

  useEffect(() => {
    if (period) {
      const dates: Dayjs[] = []

      for (let date of period.dates) {
        dates.push(dayjs(date))
      }

      setDates(dates)
    }
  }, [period, isWeekInterval])

  return {dates}
}
